<template>
  <div class="standard-card">
    <header>
      <div class="card-title" v-html="title"></div>
    </header>
    <main :class="{ has: hasDesc }">
      <div v-if="hasDesc" class="desc">
        <div class="desc-title" v-html="desc.title"></div>
        <ul>
          <li v-for="(text, index) in desc.texts" :key="index">{{ text }}</li>
        </ul>
      </div>
      <div class="btn-group">
        <el-button plain color="#3461FF" @click="preview" class="btn2">预览</el-button>
        <el-button type="primary" color="#3461FF" @click="download" class="btn1">下载</el-button>
      </div>
    </main>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
export interface StandardCardProps {
  title: string
  desc?: {
    title: string
    texts: string[]
  }
}

const props = defineProps<StandardCardProps>()
const hasDesc = computed(() => props.desc)
const emit = defineEmits<{
  (e: 'preview'): void
  (e: 'download'): void
}>()

const preview = () => {
  emit('preview')
}

const download = () => {
  emit('download')
}

</script>

<style lang="scss" scoped>
.standard-card {
  box-sizing: border-box;
  width: 376px;
  border: 1px solid #F4F4F5;

  &:hover {
    box-shadow: 8px 8px 20px 0px rgba(55, 99, 170, 0.1);
  }



  header {
    height: 158px;
    background: url('~@/assets/img/standard/standard-card-header-bg.png') no-repeat center/100% 100%;
    overflow: hidden;
    display: flex;
    justify-content: center;
    flex-direction: column;




    h3 {
      width: 220px;
      margin: 32px auto 0;
      font-size: 20px;
      text-align: center;
      font-weight: 500;
      line-height: 24px;
    }

    .card-title {
      color: #000;
      text-align: center;
      
      font-size: 20px;
      font-style: normal;
      font-weight: 500;
    }
  }

  main {
    padding: 32px 14px 30px;
    background-color: #F3F5F8;
    border: 2px solid #FFFFFF;
    border-top: 0;

    &.has {
      padding-top: 35px;
      padding-bottom: 46px;
    }

    .desc {
      height: 186px;
      font-size: 14px;
      font-weight: 400;
      line-height: 22px;

      .desc-title {
        margin-bottom: 16px;
        color: #636E80;

        ::v-deep(span) {
          color: #3461FF;
        }
      }

      li {
        display: flex;
        margin-bottom: 4px;
        color: #1D2129;

        &::before {
          content: '';
          display: block;
          flex-shrink: 0;
          width: 16px;
          height: 16px;
          margin-top: 3px;
          margin-right: 12px;
          background: url('~@/assets/img/standard/check.png') no-repeat center center/100% 100%;
        }
      }
    }

    .btn-group {
      display: flex;
      justify-content: space-between;

      ::v-deep(.el-button) {
        width: 156px;
        height: 40px;

        &.is-plain {
          background-color: #FFFFFF;

          &:hover {
            background-color: #3461FF;
          }
        }
      }
    }
  }
}

.btn1 {
  background-color: #3461FF;
  height: 40px;
  width: 50%;
  font-size: 14px;
  border: none;
}

.btn1:hover {
  background-color: #5D81FF;

}

.btn2:hover {
  color: #FFFFFF;
}
</style>